import { useEffect, useState } from 'react';
// return object where key is an id from given array that is not uniq
export const useUniqNamesErrors = (names) => {
    const [errors, setErrors] = useState(null);
    useEffect(() => {
        const nameErrors = {};
        const namesIdMap = {};
        names.forEach((name, idx) => {
            const existedId = namesIdMap[name];
            if (typeof existedId !== 'undefined') {
                nameErrors[idx] = true;
                nameErrors[existedId] = true;
                return;
            }
            namesIdMap[name] = idx;
        });
        setErrors(Object.keys(nameErrors).length ? nameErrors : null);
    }, [names]);
    return errors;
};
//# sourceMappingURL=useUniqNameErrors.js.map